import { IKnmViolationType } from 'APIPackage/CatalogsModule/interfaces/IKnmViolationType';

import { IKnmViolationTypeSelectOption } from '../interfaces/IKnmViolationTypeSelectOption';

export const createKnmViolationTypeSelectOption = (
  knmViolationType: IKnmViolationType,
): IKnmViolationTypeSelectOption => ({
  ...knmViolationType,
  label: knmViolationType.name,
  value: knmViolationType.code,
});
